module.exports = __webpack_public_path__ + "static/shareAir1BG-dd404965f6e0cd7e34362ef71c74ea58.png";